import { Science } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useContext } from 'react';

import { UserContext } from '~/auth/userContext';
import { liftAiAuth } from '~/utils/api';

/**
 * Shown on every page to anyone signed in to a demo account, so nobody
 * mistakes its fictional data for a real customer's. Sits above the
 * impersonation banner when staff impersonate a demo user.
 */
export function DemoBanner() {
  const { userDetails } = useContext(UserContext);

  if (!userDetails.isDemo) {
    return null;
  }

  const impersonating = Boolean(liftAiAuth().getImpersonation());

  return (
    <Box
      role="status"
      sx={{
        position: 'fixed',
        bottom: impersonating ? 48 : 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.drawer + 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        px: 2,
        py: 0.75,
        bgcolor: 'info.main',
        color: 'info.contrastText',
        boxShadow: 4,
      }}
    >
      <Science fontSize="small" />
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        You are signed in to a demo account. All data is fictional, and emails, invites and support
        requests are simulated.
      </Typography>
    </Box>
  );
}
